export default __webpack_public_path__ + "static/media/Manuable_paqueteria_local.fe4c2079.png";